/**
 * Modified from https://github.com/melt-ui/next-gen/blob/main/packages/melt/src/lib/Synced.svelte.ts
 */
import { extract } from './extract.svelte.js';
import { isFunction } from './is.js';
/**
 * A reactive class that runs a callback every time its property `current`
 * changes. This offers a simple way of running reactive changes.
 */
export class Synced {
    #internalValue = $state();
    #valueArg;
    #onChange;
    #defaultValue;
    constructor({ value, onChange, ...args }) {
        this.#valueArg = value;
        this.#onChange = onChange;
        this.#defaultValue = 'defaultValue' in args ? args?.defaultValue : undefined;
        this.#internalValue = extract(value, this.#defaultValue);
    }
    get current() {
        return isFunction(this.#valueArg)
            ? (this.#valueArg() ?? this.#defaultValue ?? this.#internalValue)
            : this.#internalValue;
    }
    set current(value) {
        if (this.current === value)
            return;
        if (isFunction(this.#valueArg)) {
            this.#onChange?.(value);
            return;
        }
        this.#internalValue = value;
        this.#onChange?.(value);
    }
}
